/**
 * 课程相关API接口
 * 实现课程列表、详情、购买、订单查询等功能
 */

import { req } from '../utils/request'

export class Course {
  /**
   * 获取课程分类列表
   * @param {Object} params - { parent_id, status }
   * @returns {Promise}
   */
  getCategoryList(params) {
    return req.get('user.course/categoryList', params)
  }
  
  /**
   * 获取课程列表
   * @param {Object} params - { category_id, status, page, limit }
   * @returns {Promise}
   */
  getCourseList(params) {
    return req.get('user.course/list', params)
  }
  
  /**
   * 获取课程详情
   * @param {Number} id - 课程ID
   * @returns {Promise}
   */
  getCourseDetail(id) {
    return req.get('user.course/detail', { id })
  }
  
  /**
   * 购买课程（支持多个课程）
   * @param {Array} courseIds - 课程ID数组 [1, 2, 3]
   * @returns {Promise}
   */
  purchaseCourses(courseIds) {
    return req.post('user.course/purchase', { course_ids: courseIds })
  }
  
  /**
   * 获取我的课程订单
   * @param {Object} params - { course_status, page, limit }
   * @returns {Promise}
   */
  getMyOrders(params) {
    return req.get('user.course/myOrders', params)
  }
  
  /**
   * 获取订单详情
   * @param {String} orderNo - 订单编号
   * @returns {Promise}
   */
  getOrderDetail(orderNo) {
    return req.get('user.course/orderDetail', { order_no: orderNo })
  }

  /**
    * 购买课程创建课程订单并拉起支付
    * @param {Object} params - 请求参数
    * @param {Array} params.course_ids - 课程ID数组，如：[1, 2, 3]（必填）
    * @param {string} params.payment_type - 支付类型：wechat（微信）/ alipay（支付宝）（必填）
    * @param {string} params.payment_method - 支付方式：mp/h5/wxapp/app/native/page/faceToFace/precreate（必填）
    * @param {string} params.openid - 微信openid（微信mp/wxapp支付必填）
    * @param {string} params.sub_openid - 子商户openid（服务商模式可选）
    * @param {string} params.return_url - 支付完成返回地址（h5/page支付可选）
    * @param {string} params.quit_url - 支付宝H5支付取消返回地址（可选）
    * @param {string} params.auth_code - 付款码（支付宝当面付必填）
    * @param {string} params.product_id - 商品ID（微信Native支付可选）
    * @returns {Promise<Object>} 返回订单信息和支付参数
    * @description 需要会员权限。支付方式说明：
    * 微信支付：mp(公众号)、h5(H5)、wxapp(小程序)、app(APP)、native(扫码)
    * 支付宝：h5(手机网站)、app(APP)、page(电脑网站)、faceToFace(当面付)、precreate(预创建)
    * @author System (2026-03-17)
    */
   purchaseCourse(params) {
     return req.post('user.course/purchase', params)
   }
}

export default new Course()
